import ajax from './ajax'

// 1. 基础路径
//const BASE_URL = '';
// const BASE_URL = 'http://ai.dayuyoupin.com/dgx/v1.0.0'
const BASE_URL = 'http://mxy01.deepbaytech.com'

// 2. 请求方法

// 2.1 请求新闻资讯
export const getNewsCasual = () => ajax(BASE_URL + '/empowermentCenter/getInformationCategoryListWithInformationDesc')
// 2.2 新闻内页
export const getNewsContent = (informationId, orderType) => ajax(BASE_URL + '/aiCollege/informationContent', { informationId, orderType })
// 2.3 新闻热门推荐
export const getNewsHot = () => ajax(BASE_URL + '/aiCollege/hotRecommendList')
// 2.4  服务咨询
export const getServiceConsultation = (paramsObj) =>ajax(BASE_URL + '/admin/consulting/contact', { ...paramsObj },'POST')

